import { DisplayUnitsState } from './types';

export const DEFAULT_DISPLAY_UNITS_STATE: DisplayUnitsState = {
  defaultNumberOfUnits: undefined,
  maxNumberOfUnits: undefined,
};
